
import { Main } from "./components/main/main";
import { AboutMe } from "./components/aboutme/aboutme";
import { Portfolio } from "./components/portfolio/portfolio";
import { Services } from "./components/packageuslug/packageuslug";
import { Sertificate } from "./components/sertificates/sertificates";




function Home() {
  return (
    <div className="">
      <Main />
      <AboutMe />
      <Portfolio />
      <Services />
      <Sertificate />
    </div>
  );
}

export default Home;
